(function () {
  'use strict';

  var SUPPRESSED_CLASS = 'is-colulu-lp-footer-suppressed';
  var initializedCtas = new WeakSet();

  function initialize(root) {
    var scope = root || document;
    var ctas = scope.matches && scope.matches('.lp-float-cta')
      ? [scope]
      : Array.prototype.slice.call(scope.querySelectorAll('.lp-float-cta'));

    ctas.forEach(function (cta) {
      if (initializedCtas.has(cta)) return;
      initializedCtas.add(cta);

      var lpSection = cta.closest('.shopify-section');
      var footer = lpSection && lpSection.querySelector('.custom-lp__wrapper footer');
      if (!footer) return;

      var ticking = false;
      var update = function () {
        ticking = false;
        var footerVisible = footer.getBoundingClientRect().top < window.innerHeight;
        cta.classList.toggle(SUPPRESSED_CLASS, footerVisible);
        if (footerVisible) {
          cta.setAttribute('aria-hidden', 'true');
          cta.setAttribute('inert', '');
        } else {
          cta.removeAttribute('aria-hidden');
          cta.removeAttribute('inert');
        }
      };
      var requestUpdate = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      requestUpdate();
    });
  }

  function boot() {
    initialize(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
}());
